import React, { useContext } from "react"
import { GlobalDataContext } from "../context/context"
import BaseLayout from "../components/global/BaseLayout"
import Modal from "../components/Home/Modal"
import HeroSection from "../components/Home/HeroVideo"
import BlockContentPrincipal from "../components/block/BlockContent_1"
import CallToActionBlockTopAbout from '../components/callToAction/CallToAction_1'
import BlockContentAbout from "../components/block/BlockContent_2"
import ValuesContent from '../components/values/Values_1'
import Directories from "../components/Home/Directories";
import VideoPromocional from "../components/global/VideoPromocional";
import ServicesHome from '../components/Services/ServicesHome_1'
import CallToAction2 from '../components/callToAction/CallToAction_2'
import Map from "../components/Contact/MapContent"
import Form from "../components/Contact/Form"
import ContentServices from "../components/Services/ContentServices"
import Paletacolor from "../components/global/Paletacolor";
import GalleryContent from "../components/Gallery/GalleryContent";



// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {

  const { rpdata } = useContext(GlobalDataContext);

  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">

        <Modal />

        <HeroSection
        urlVideo={"https://firebasestorage.googleapis.com/v0/b/imagenessanti-2a052.appspot.com/o/tile%20installation.mp4?alt=media&token=39f6535d-9d4e-43c8-b39b-91fcd917aeae"}
        />

    <img src="https://firebasestorage.googleapis.com/v0/b/imagenessanti-2a052.appspot.com/o/EXPERIENCIA_Mesa%20de%20trabajo%2015.png?alt=media&token=660addc0-34a8-466c-8299-f3070c44112b"
      alt="sello"
    className="absolute -bottom-[320px] right-0 w-[200px] md:w-[250px] lg:w-[400px]"/> 

        <BlockContentPrincipal
          sloganPrincipal
          listServices
          texts={rpdata?.dbHome?.[0].text}
          images={rpdata?.gallery?.[5]}
        />

        {/* call to action va junto con el blockContent_2 */}
        <CallToActionBlockTopAbout
          title={rpdata?.dbSlogan?.[3]?.slogan}
          texts={rpdata?.dbHome?.[1].text}
          images={rpdata?.gallery?.[4]}
        />
        <BlockContentAbout
          title={'a little about us'}
          texts={rpdata?.dbAbout?.[0]?.text}
          listAbout
          images={rpdata?.gallery?.[2]}
          bgImages={rpdata?.gallery?.[4]}
        />

        <ValuesContent
          mission={rpdata?.dbValues?.[0].description}
          vision={rpdata?.dbValues?.[1].description}
          whychoose={rpdata?.dbValues?.[2].description}
          img1={rpdata?.gallery?.[6]}
          img2={rpdata?.gallery?.[5]}
          img3={rpdata?.gallery?.[7]}
        />

        <Directories />

        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo === true ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[2]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={`${rpdata?.videosPromo?.[0].img}`}
            />
            : null
        }

        {/* validacion si es onepages */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <ContentServices />
            :
            <ServicesHome />
        }

        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-10 pb-28">
              <h2 className="text-center pb-[50px]">{rpdata?.labels?.general?.titleGallery}</h2>
              <GalleryContent galleryImages={rpdata?.gallery?.length > 0 ? rpdata?.gallery : rpdata?.stock} />
            </div>
            :
            null

        }
        
        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }

        <CallToAction2
          title={rpdata?.dbSlogan?.[4]?.slogan}
          subtitle={rpdata?.dbSlogan?.[0]?.slogan}
          phone={rpdata?.dbPrincipal?.phones?.[0]?.phone}
          bgImages={rpdata?.gallery?.[1]}
        />

        {/* our reviews */}
        {
          rpdata?.reviews?.isHomeOnly === true ?
            <div className="w-4/5 mx-auto py-[100px]">
              <h1 className="pb-10 text-center">{rpdata?.labels?.general?.titleReviews}</h1>
              <div className={`${rpdata?.reviews?.links?.[0]}`}></div>
            </div>
            : null
        }

        <Map
          // para cambiar el svgclas busque la clase en el archivo svgStyles
          svgClass={'svgMap2'}
        />

        <div className='w-full flex justify-center mb-20'>
          <div className='max-w-2xl p-5 mx-5 bg-white shadow-lg '
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <h2 className='text-center'>Send Us A Message</h2>
            <div className='p-4'>
              <Form />
            </div>
          </div>
        </div>

      </div>
    </BaseLayout>
  );
}

export default Home;
